import {apiAction} from './helper';

export const GET_LAMP_TYPES = apiAction('GET_LAMP_TYPES');
export const UPDATE_LAMP_TYPE = apiAction('UPDATE_LAMP_TYPE');
export const CREATE_LAMP_TYPE = apiAction('CREATE_LAMP_TYPE');
export const DELETE_LAMP_TYPE = apiAction('DELETE_LAMP_TYPE');

